import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { assetSubRoutes } from '../assets/assetSubRoutes';
import { WorkspaceDuplicatePage } from './components/workspaceDuplicatePage';
import { WorkspaceEdit } from './components/workspaceEdit';
import { WorkspaceNewPage } from './components/workspaceNewPage';
import { Workspaces } from './components/workspaces';
import { WorkspacesFilterPage } from './components/workspacesFilterPage';
import { WorkspacesToolbar } from './components/workspacesToolbar';

export const workspacePaths = {
  root: 'workspaces',
};

export const workspaceRoute = [
  {
    path: `${workspacePaths.root}/*`,
    element: <Workspaces />,
    handle: {
      header: {
        titleKey: 'admin.menu.workspaces',
        icon: 'group',
      },
      requiredPermission: Permissions.workspace.all,
      toolbar: <WorkspacesToolbar />,
    },
  },
  {
    path: `${workspacePaths.root}/new`,
    element: <WorkspaceNewPage />,
    handle: {
      header: {
        titleKey: 'admin.menu.workspaces',
        icon: 'group',
      },
      requiredPermission: Permissions.workspace.create,
    },
  },
  {
    path: `${workspacePaths.root}/:workspaceId/duplicate`,
    element: <WorkspaceDuplicatePage />,
    handle: {
      header: {
        titleKey: 'admin.menu.workspaces',
        icon: 'group',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
  {
    path: `${workspacePaths.root}/filters`,
    element: <WorkspacesFilterPage />,
    handle: {
      header: {
        titleKey: 'admin.menu.workspaces',
        icon: 'group',
      },
      requiredPermission: Permissions.workspace.all,
    },
  },
  {
    path: `${workspacePaths.root}/:workspaceId/edit`,
    element: <WorkspaceEdit />,
    handle: {
      header: {
        titleKey: 'workspace.editTitle',
        icon: 'group',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
  // Shared asset sub-routes mounted under the workspace asset path.
  // Mirrors assets/routes.tsx and activity/routes.tsx — all activity/routine/
  // file/edit sub-pages for a workspace asset are handled here.
  ...assetSubRoutes.map((r) => ({
    ...r,
    path: `${workspacePaths.root}/:workspaceId/asset/:assetId/${r.path}`,
    handle: {
      ...r.handle,
      header: { titleKey: 'admin.menu.workspaces', icon: 'group' },
      requiredPermission: Permissions.globalAdmin,
    },
  })),
];
